import React from 'react';
import './PortfolioUserCard.css';
import { UserHelper } from 'view/helpers';

const PortfolioUserCard = ({
	user,
	isAddUser = false,
	onClick,
	onEdit,
	onDelete,
	showActions = false,
}) => {
	if (isAddUser) {
		return (
			<div className="portfolio-user-card add-user-card" onClick={onClick}>
				<div className="portfolio-user-avatar add-user-avatar">
					<i className="bi bi-plus" />
				</div>
				<div className="portfolio-user-name">Add User</div>
			</div>
		);
	}

	return (
		<div className="portfolio-user-card" onClick={onClick} title={user.name}>
			<div
				className="portfolio-user-avatar"
				style={{ backgroundColor: UserHelper.getAvatarColor(user.name || user.email || user.id) }}
				title={user.name}
			>
				{UserHelper.getShortName(user.name)}
			</div>
			<div className="portfolio-user-name">{user.name}</div>
			<div className="portfolio-user-role">{user.role}</div>
			{user.is_pending && (
				<div className="portfolio-user-status">
					<span className="status-badge status-pending">
						<i className="bi bi-clock-history me-1"></i>
						Pending Activation
					</span>
				</div>
			)}
			{user.added_by_user_name && (
				<div className="portfolio-user-added-by">
					<small className="text-muted">
						<i className="bi bi-person-plus me-1"></i>
						Added by {user.added_by_user_name}
					</small>
				</div>
			)}
			{showActions && (onEdit || onDelete) && (
				<div className="portfolio-user-actions mt-2">
					{onEdit && (
						<button
							className="btn btn-sm btn-primary me-1"
							onClick={(e) => {
								e.stopPropagation();
								onEdit(user);
							}}
							title="Edit user role"
						>
							<i className="bi bi-pencil" />
						</button>
					)}
					{onDelete && (
						<button
							className="btn btn-sm btn-outline-danger"
							onClick={(e) => {
								e.stopPropagation();
								onDelete(user);
							}}
							title="Remove user"
						>
							<i className="bi bi-trash" />
						</button>
					)}
				</div>
			)}
		</div>
	);
};

export default PortfolioUserCard;
